import { Element, Level, Title } from '@zmedia/bm-soccer-ui/components';
import { memo } from 'react';
import { IPromotion } from '@zmedia/bm-soccer-ui/interface';
import { ArrayUtils } from '@zmedia/bm-soccer-ui/utils';
import styles from './style.module.scss';

function TableFooter({ promotions = [] }: { promotions: IPromotion[] }) {
    if (ArrayUtils.isEmpty(promotions)) {
        return null;
    }

    return (
        <Element className={styles['table-footer']}>
            <Level>
                <Level.Side align="left">
                    <Level.Item>
                        <Title subtitle renderAs="h4">
                            Vòng loại / Xuống hạng
                        </Title>
                    </Level.Item>
                    {promotions.map((promotion: IPromotion, index) => {
                        return (
                            <Level.Item key={index}>
                                <Element
                                    renderAs="span"
                                    className={styles['color']}
                                    style={
                                        {
                                            backgroundColor: `${promotion.color}`,
                                        } as React.CSSProperties
                                    }
                                ></Element>
                                <Element className={styles['text']}>
                                    {promotion.name}
                                </Element>
                            </Level.Item>
                        );
                    })}
                </Level.Side>

                <Level.Side align="right">
                    <Level.Item>
                        <Title subtitle renderAs="h4">
                            5 trận gần nhất
                        </Title>
                    </Level.Item>
                    <Level.Item>
                        <Element
                            renderAs="span"
                            className={styles['color']}
                            style={
                                {
                                    backgroundColor: '#3fae29',
                                } as React.CSSProperties
                            }
                        >
                            T
                        </Element>
                        <Element className={styles['text']}>Thắng</Element>
                    </Level.Item>
                    <Level.Item>
                        <Element
                            renderAs="span"
                            className={styles['color']}
                            style={
                                {
                                    backgroundColor: '#808080',
                                } as React.CSSProperties
                            }
                        >
                            H
                        </Element>
                        <Element className={styles['text']}>Hòa</Element>
                    </Level.Item>
                    <Level.Item>
                        <Element
                            renderAs="span"
                            className={styles['color']}
                            style={
                                {
                                    backgroundColor: '#dd3333',
                                } as React.CSSProperties
                            }
                        >
                            B
                        </Element>
                        <Element className={styles['text']}>Thua</Element>
                    </Level.Item>
                </Level.Side>
            </Level>
        </Element>
    );
}

export default memo(TableFooter);
